import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/page-layout.css';
import './styles/typography.css';
import App from './App';
import { Provider } from "react-redux";
import store from "../src/redux/store";
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { theme } from '@ace/ace-ui-web';
import { Toaster } from 'sonner';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Provider store={store}>
                <App />
                <Toaster position="top-center" richColors />
            </Provider>
        </ThemeProvider>
    </React.StrictMode>
);